import React, {useState} from 'react'
import {ItemTitle, labelStyles} from './TwoFaSettings.styles'
import {CustomButton, TextInputGroup} from "components/common";
import {Column, Form} from "../PasswordSettings/ChangePassword/ChangePassword.styles";
import { useTranslation } from 'react-i18next';

interface Props {
    user: any,
    onChangeTwoFa: any,
    onSubmitPhoneNumber: any,
    isLoading2FA: boolean,
    isLoadingPhone: boolean,
}

const TwoFaSettings: React.FC<Props> = ({
                                            user,
                                            onChangeTwoFa,
                                            onSubmitPhoneNumber,
                                            isLoading2FA,
                                            isLoadingPhone,
                                        }) => {

    const [phoneNumber, setPhoneNumber] = useState(user.phoneNumber)
    const {t} = useTranslation()

    const handleTwoFactorAuthorizationChange = (status: boolean) => {
        onChangeTwoFa(status)
    }

    const handlePhoneNumberSubmitChange = () => {
        onSubmitPhoneNumber(phoneNumber)
    }

    return (
        <Column>
            <Form>
                <ItemTitle>{t('2fa')}</ItemTitle>
                {user.phoneNumber ? (<React.Fragment>
                    {user.twoFaEnabled ? (
                        <CustomButton
                            onClick={() => handleTwoFactorAuthorizationChange(false)}
                            btntype='error'
                            size='large'
                            disabled={isLoading2FA}
                            width={250}
                            style={{marginBottom: 16}}
                        >
                            {!isLoading2FA ? '2FA deaktivieren' : 'Einen Moment bitte...'}
                        </CustomButton>
                    ) : (
                        <CustomButton
                            onClick={() => handleTwoFactorAuthorizationChange(true)}
                            btntype='success'
                            size='large'
                            disabled={isLoading2FA}
                            width={250}
                            style={{marginBottom: 16}}
                        >
                            {!isLoading2FA ? '2FA aktivieren' : 'Einen Moment bitte...'}
                        </CustomButton>
                    )}
                    <ItemTitle>&nbsp;</ItemTitle>
                </React.Fragment>) : (<span>&nbsp;</span>)}
                <ItemTitle>{t('mobile_number')}</ItemTitle>
                <TextInputGroup
                    disabled={!user.twoFaEnabled && user.phoneNumber !== ''}
                    type='text'
                    key={'phoneNumber'}
                    name={'Phone Number'}
                    value={phoneNumber}
                    placeholder={'z. Bsp.: +41 79 123 45 67'}
                    onChange={(event) => {
                        // @ts-ignore
                        setPhoneNumber(event.target.value)
                    }}
                    label={t('insert_mobile_number')}
                    LabelProps={{
                        style: labelStyles,
                    }}
                />
                {!user.phoneNumber ? (
                    <CustomButton
                        disabled={phoneNumber?.length === 0}
                        btntype='primary'
                        size='large'
                        onClick={() => handlePhoneNumberSubmitChange()}
                        isLoading={false}
                        width={250}
                        style={{marginTop: 1}}
                    >
                        {!isLoadingPhone ? t('save_activate') : 'Einen Moment bitte...'}
                    </CustomButton>
                ) : (
                    <CustomButton
                        disabled={!user.twoFaEnabled}
                        type='submit'
                        btntype='primary'
                        size='large'
                        isLoading={false}
                        width={250}
                        style={{marginTop: 1}}
                    >
                        {!isLoadingPhone ? 'Handynummer aktualisieren' : 'Einen Moment bitte...'}
                    </CustomButton>
                )}
            </Form>
        </Column>
    )
}

export default TwoFaSettings
